import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { siteConfig } from "../siteConfig";
import ReviewCard from "../components/ReviewCard";
import Reveal from "../components/Reveal";

const ReviewsPage = () => (
  <>
    <section className="pt-32 pb-16" style={{ backgroundColor: siteConfig.colors.dark }}>
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="flex justify-center gap-0.5 mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />)}
        </div>
        <h1 className="font-display font-black text-white leading-tight" style={{ fontSize: "clamp(2rem,5vw,3.5rem)" }}>
          Customer Reviews
        </h1>
        <p className="mt-4 text-white/60 text-lg max-w-2xl mx-auto">
          Don't just take our word for it — here's what our customers say.
        </p>
      </div>
    </section>

    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {siteConfig.reviews.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 90}>
              <ReviewCard review={r} />
            </Reveal>
          ))}
        </div>

        {siteConfig.googleReviewLink !== "#" && (
          <Reveal className="text-center">
            <a
              href={siteConfig.googleReviewLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 px-8 h-14 font-bold rounded-xl text-white transition-opacity hover:opacity-90"
              style={{ backgroundColor: siteConfig.colors.primary }}
            >
              <ExternalLink className="w-4 h-4" />
              Leave Us a Google Review
            </a>
          </Reveal>
        )}
      </div>
    </section>

  </>
);

export default ReviewsPage;
